import type { Node, NodeProps } from "@xyflow/react";

/**
 * ADR-0212 §3.7, §4.6 — a note on a subject area's canvas: plain text in a
 * box sized to its text. It has no handles (it joins nothing), it is not in
 * the catalog, and auto layout leaves it where it is. Its text is edited in
 * the inspector; an empty note shows a muted "Note" so it can still be found.
 */
export type SemanticNoteNodeType = Node<{ text: string }, "semanticNote">;

/** React Flow ids for notes carry this prefix, so a note can never collide with an object id. */
export const NOTE_NODE_PREFIX = "note:";

export function noteNodeId(noteId: string): string {
  return `${NOTE_NODE_PREFIX}${noteId}`;
}

/** The note id behind a canvas node id, or null when the node is not a note. */
export function noteIdOfNode(nodeId: string): string | null {
  return nodeId.startsWith(NOTE_NODE_PREFIX) ? nodeId.slice(NOTE_NODE_PREFIX.length) : null;
}

export function SemanticNoteNode({ data }: NodeProps<SemanticNoteNodeType>) {
  const text = data.text;
  return <div className="semanticNoteNode">{text.trim() ? text : <span className="muted">Note</span>}</div>;
}
